var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#32A840",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4167 23.9203H22.0667C22.7167 23.9203 23.2567 23.3403 23.2567 22.6403C23.2567 21.7703 22.9467 21.6003 22.4367 21.4203L21.4267 21.0703V23.9203H21.4167Z",
    fill: "#32A840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6367 9.90041C15.1167 9.92041 10.6467 14.4104 10.6667 19.9304C10.6867 25.4504 15.1767 29.9204 20.6967 29.9004C26.2167 29.8804 30.6867 25.3904 30.6667 19.8704C30.6467 14.3504 26.1567 9.89041 20.6367 9.90041ZM22.9267 20.0004C23.7067 20.2704 24.7567 20.8504 24.7567 22.6404C24.7567 24.1804 23.5467 25.4204 22.0667 25.4204H21.4167V26.0004C21.4167 26.4104 21.0767 26.7504 20.6667 26.7504C20.2567 26.7504 19.9167 26.4104 19.9167 26.0004V25.4204H19.5567C17.9167 25.4204 16.5867 24.0404 16.5867 22.3404C16.5867 21.9304 16.9267 21.5904 17.3367 21.5904C17.7467 21.5904 18.0867 21.9304 18.0867 22.3404C18.0867 23.2104 18.7467 23.9204 19.5567 23.9204H19.9167V20.5404L18.4067 20.0004C17.6267 19.7304 16.5767 19.1504 16.5767 17.3604C16.5767 15.8204 17.7867 14.5804 19.2667 14.5804H19.9167V14.0004C19.9167 13.5904 20.2567 13.2504 20.6667 13.2504C21.0767 13.2504 21.4167 13.5904 21.4167 14.0004V14.5804H21.7767C23.4167 14.5804 24.7467 15.9604 24.7467 17.6604C24.7467 18.0704 24.4067 18.4104 23.9967 18.4104C23.5867 18.4104 23.2467 18.0704 23.2467 17.6604C23.2467 16.7904 22.5867 16.0804 21.7767 16.0804H21.4167V19.4604L22.9267 20.0004Z",
    fill: "#32A840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 17.3701C18.0868 18.2401 18.3968 18.4101 18.9068 18.5901L19.9168 18.9401V16.0801H19.2668C18.6168 16.0801 18.0868 16.6601 18.0868 17.3701Z",
    fill: "#32A840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.18ca78a77053224391d4401da23b5d35.svg";
export { ForwardRef as ReactComponent };